import React, { useEffect, useState } from 'react';

import EventCartDesktop from './sections/EventCartDesktop';
import { TicketsContextProvider } from '@/contexts/tickets/TicketsContext';
import {
  useTicketsSelected,
  useResetStore,
  usePayment,
  useBooking,
} from '@/store';
import useSummaryUpdate from '@/store/summary/useSummaryUpdate';
import EventCartMobile from './sections/EventCartMobile';
import useMobile from '@/hooks/useMobile';

export default function Home({ isMobile: isSsrMobile }) {
  const [isMobile, setIsMobile] = useState(isSsrMobile);
  const { isMobile: isCsrMobile } = useMobile();
  const { resetBooking, setStartDate } = useBooking();
  const { resetBookingPayment } = usePayment();
  const { restore } = useResetStore();
  const { removeAllTickets } = useTicketsSelected();
  useSummaryUpdate('index');

  useEffect(() => {
    resetBooking();
    setStartDate();
    removeAllTickets();
    restore();
    resetBookingPayment();
  }, []);

  useEffect(() => {
    setIsMobile(isCsrMobile);
  }, [isCsrMobile]);

  return (
    <TicketsContextProvider>
      {isMobile && <EventCartMobile />}
      {!isMobile && <EventCartDesktop />}
    </TicketsContextProvider>
  );
}
